import { usePostJson } from "../hooks/usePostJson";
import Loading from "../tabs/loading";
import { setFcwdOnly } from "../../utils/data";
import { canadianProvinces } from "../../utils/countryOptions";
//import { useNavigate } from "react-router-dom";


export default function PostConviction({data, fcwdOnly, auth}){

    //const navigate = useNavigate();
    console.log("Conviction: "+JSON.stringify(data));

    const url = "/api/conviction/add" 


    const res = usePostJson(url, data, "POST", auth);

    while(res.loading){
        return(<Loading />)
    }

    console.log(JSON.stringify(data))


    if(res?.response?.Error === "Internal Server error"){
        return(<></>)
    }

    if(res?.response?.Status === "SUCCESS"){
        const st = data.Body.License.JurisdictionOfIssue;
        const lic = data.Body.License.LicenseNumber;
/*
        if((canadianProvinces.find(v => v.code === st)) || (st === "MX")){
            setFcwdOnly(false) 
        } else {
            setFcwdOnly(true);
        }
*/
    const url = "/driver/" + st + "/" + encodeURIComponent(lic) + "/" + fcwdOnly;
    window.location.replace(url);

    }  

    console.log("Withdrawal Post Response: "+JSON.stringify(res));

    //alert(JSON.stringify(res.response))
    //window.location.replace(basePage)

    if(res?.response?.Status === "ERROR"){

        return(
            <div  style={{ color: 'red' }}>
                <>{res?.response?.Transaction}</> &nbsp;
                <>{res?.response?.Messages[0]}</>

            </div>
        )   
    }

    return(
        <div>
        <Loading />
        </div>
    )
}
